/**
 * Vite 入口 — 装配自研 Rivmoon Console Design System + React 19 root
 *
 * 设计 token 全局样式从 ~/styles/tokens.css 注入（自研 Rivmoon Console DS，无第三方 UI 库）；
 * 业务路由 / TanStack Query / Toast 在 <App /> 内装配
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '~/App';
import { installAuthCrossTabSync } from '~/stores/auth-cross-tab-sync';
import '~/styles/tokens.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');

// 多 tab 共享登录态：他 tab 续期 / 登出 / 换号后本 tab 立即跟随（防 tab 间互相作废 token 被踢登录）
installAuthCrossTabSync();

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
